import React from 'react';
import PropTypes from 'prop-types';
import styles from './expand-button.module.scss';
const ExpandButton = props => {
  return (
    <button className={styles.expandButton} onClick={props.onClick}>
      Expand{' '}
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13">
        <path
          fill="#323232"
          fillRule="evenodd"
          d="M7.574 5.094v.562a.271.271 0 0 1-.082.2.271.271 0 0 1-.199.082H5.699V7.53a.271.271 0 0 1-.082.2.271.271 0 0 1-.199.082h-.563a.271.271 0 0 1-.199-.083.271.271 0 0 1-.082-.199V5.938H2.98a.271.271 0 0 1-.199-.083.271.271 0 0 1-.082-.199v-.562c0-.078.028-.145.082-.2a.271.271 0 0 1 .2-.081h1.593V3.219c0-.078.028-.145.082-.2a.271.271 0 0 1 .2-.081h.562c.078 0 .144.027.2.082a.271.271 0 0 1 .081.199v1.594h1.594c.078 0 .144.027.2.082a.271.271 0 0 1 .081.199zm4.617 6.797l-.539.515a.291.291 0 0 1-.21.094.223.223 0 0 1-.188-.094L8.418 9.57a.223.223 0 0 1-.094-.187v-.328c-.437.375-.93.668-1.476.879a4.714 4.714 0 0 1-1.711.316c-.89 0-1.707-.219-2.45-.656a4.925 4.925 0 0 1-1.769-1.77 4.735 4.735 0 0 1-.656-2.449c0-.89.218-1.707.656-2.45a4.925 4.925 0 0 1 1.77-1.769A4.735 4.735 0 0 1 5.136.5c.89 0 1.707.219 2.449.656a4.925 4.925 0 0 1 1.77 1.77c.437.742.656 1.558.656 2.449 0 .594-.106 1.164-.317 1.71a5.035 5.035 0 0 1-.879 1.478h.329c.062 0 .125.03.187.093l2.86 2.836c.046.047.07.11.07.188a.343.343 0 0 1-.07.21zM8.887 5.375c0-.672-.168-1.297-.504-1.875a3.723 3.723 0 0 0-1.371-1.371 3.668 3.668 0 0 0-1.875-.504c-.672 0-1.297.168-1.875.504A3.723 3.723 0 0 0 1.89 3.5a3.668 3.668 0 0 0-.504 1.875c0 .672.168 1.297.504 1.875a3.723 3.723 0 0 0 1.37 1.371 3.668 3.668 0 0 0 1.876.504c.672 0 1.297-.168 1.875-.504a3.723 3.723 0 0 0 1.37-1.371 3.668 3.668 0 0 0 .505-1.875z"
        />
      </svg>
    </button>
  );
};

ExpandButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
export default ExpandButton;



// WEBPACK FOOTER //
// ./src/components/expand-button/expand-button.js